export function handleVariantSelection(): void {
  const sizesSelector = document.getElementById('sizes');
  const finishesSelector = document.getElementById('finishes');

  sizesSelector?.addEventListener('click', event => getSelectedVariant(event));
  finishesSelector?.addEventListener('click', event => getSelectedVariant(event));
}

function getSelectedVariant(event: Event): void {
  const target = event.target as HTMLElement;
  const selectedVariant = target.closest('li button') as HTMLElement | null;

  if (!selectedVariant) return;

  const { currentFinish, currentSize, currentDimension, finish: selectedFinish, size: selectedSize, dimension: selectedDimension } = selectedVariant.dataset;
  const finalFinish = currentFinish || selectedFinish;
  const finalSize = currentSize || selectedSize;
  const selectedColorway = selectedVariant.closest('ul')?.dataset.activeColor;

  if (finalSize && finalFinish && selectedColorway) {

    let querySelector = `#colors a[data-size="${finalSize}"][data-finish="${finalFinish}"][data-colorway="${selectedColorway}"]`;
    if (selectedDimension !== currentDimension) {
      querySelector += `[data-dimension="${selectedDimension}"]`;
    }
    const targetItem = document.querySelector<HTMLAnchorElement>(querySelector);

    if (targetItem) {
      const targetPath = targetItem.getAttribute('href');
      // Ensure targetPath is not null before proceeding
      if (targetPath !== null) {
        window.location.assign(targetPath);
      } else {
        console.error("Found element does not have an 'href' attribute.");
      }
    } else {
      const fallbackSelectors = [
        `a[data-size="${finalSize}"][data-finish="${finalFinish}"]`,
        `a[data-size="${finalSize}"][data-colorway="${selectedColorway}"]`,
        `a[data-size="${finalSize}"]`,
      ];

      for (const selector of fallbackSelectors) {
        const fallbackItem = document.querySelector<HTMLAnchorElement>(`#colors ${selector}`);
        if (fallbackItem) {
          const fallbackItemPath = fallbackItem.getAttribute('href');
          if (fallbackItemPath) {
            window.location.assign(fallbackItemPath);
            break;
          }
        }
      }
    }
  }
}
